export class ApiSearchResponse<T> {
  data: T[] = [];
  limit?: number;
  skip?: number;
  total?: number;

  constructor(apiSearchResponse?: ApiSearchResponse<T>) {
    if (apiSearchResponse) {
      Object.assign(this, apiSearchResponse);
    }
  }
}
